import { render, staticRenderFns } from "./TeamIntroductionSwiper.vue?vue&type=template&id=7ec8a473&scoped=true&"
import script from "./TeamIntroductionSwiper.vue?vue&type=script&lang=js&"
export * from "./TeamIntroductionSwiper.vue?vue&type=script&lang=js&"
import style0 from "./TeamIntroductionSwiper.vue?vue&type=style&index=0&id=7ec8a473&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec8a473",
  null
  
)

export default component.exports